<template>
    <div class="modal fade" id="fastOrderModal" tabindex="-1" role="dialog" aria-labelledby="fastOrderModalTitle"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content modal-content-dvn modal-content-dvn_request">
                <div class="modal-header">
                    <h5 class="modal-title" id="fastOrderModalTitle">Быстрая заявка</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit="sendForm">
                        <p class="modal-content-dvn__subTitle">Для определения стоимости работ и
                            предоставления
                            <br><span>скидки 5%</span> заполните, пожалуйста форму-заявку:</p>

                        <div class="form-group">
                            <label for="inputName">Имя</label>
                            <input type="text" class="form-control" id="inputName" v-model="object.full_name" required>
                        </div>
                        <div class="form-group">
                            <label for="inputPhone">Телефон</label>
                            <the-mask mask="+7 (###) ###-##-##"
                                      v-model.trim="object.phone"
                                      class="form-control"
                                      id="inputPhone"
                                      placeholder="Ваш телефон"
                                      type="tel"
                                      required
                            />
                        </div>
                        <button class="btn main-button brown-btn modal-content-dvn__btn"
                                onclick="ym(12993262,'reachGoal','zajavka'); return true;"
                                :disabled="this.submitted">Отправить заявку
                        </button>

                        <p class="modal-content-dvn__subTitle text-success pb-2 pt-2" v-if="message">{{message}}</p>
                    </form>
                </div>
                <div class="modal-footer flex-column">
                    <p>Если у Вас есть чертежи (план и профиль прокола), пришлите их, пожалуйста, на электронную почту
                        <a href="mailto:info@gnb-stroy.com">info@gnb-stroy.com</a></p>
                    <p>Любые консультации можно так же получить по телефону
                        <a href="tel:+7495226-18-50">+7 (495) 226-18-50</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                object: {
                    full_name: '',
                    phone: '',
                },
                errors: [],
                message: '',
                submitted: false
            }
        },
        methods: {
            sendForm(e) {
                this.submitted = true;
                axios.post('/contact/fastOrder', {...this.object, phone: `+7${this.object.phone}`}).then(response => {
                    this.object  = {
                        full_name: '',
                        phone: '',
                    };
                    this.message = response.data.message;
                    setTimeout(() => {
                        this.message   = '';
                        this.submitted = false;
                        this.$refs.closeModal.click();
                    }, 3000);
                }).catch(response => {
                    this.errors = response.response.data.errors;
                    console.log(this.errors);
                    this.submitted = false;
                });

                e.preventDefault();
                return false;
            }
        },
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
